import { DocumentIcon } from '@/components/icons';
import { brand } from '@/styles/shared';
import { Box, Typography } from '@mui/material';
import { rightPanelStyles } from './styles';

const EmptyState = () => {
  return (
    <Box sx={rightPanelStyles.emptyState}>
      <Typography variant="body1" sx={rightPanelStyles.emptyStateTitle}>
        Nothing to show yet
      </Typography>
      <Typography variant="body2" sx={rightPanelStyles.emptyStateSubtitle}>
        Please record an audio file.
      </Typography>

      <Box sx={{
        ...rightPanelStyles.largeIconContainer,
        '& svg': {
          width: { xs: '70px', lg: '100px' },
          height: { xs: '70px', lg: '100px' },
        }
      }}>
        <DocumentIcon />
      </Box>

      <Typography variant="body2" sx={rightPanelStyles.instructions}>
        When finished click "
        <Box component="span" sx={{ color: brand.purpleAccent }}>
          End Recording
        </Box>
        " ,<br /> then click "
        <Box component="span" sx={{ color: brand.purpleAccent }}>
          Get Note
        </Box>
        " button which will appear.
      </Typography>

      <Typography variant="h6" sx={rightPanelStyles.gradientText}>
        Your A.I Co-Pilot For Medical Documentation !
      </Typography>
    </Box>
  );
};

export default EmptyState;
